"use client"

import React from "react"
import { AppContainer } from "@src/components"
import Stack from "@mui/material/Stack"
import BannerSection from "./banner-section"
import TitleSection from "./title-section"
import BodySection from "./body-section"
import OtherCollections from "./other-collections"
import RelativeProduct from "@src/sections/product-list/relative-product"
import { useTranslation } from "react-i18next"

const CollectionDetail = ({ detail, relatedCollection }) => {
  const { id, cover, name, content, products, slug, likes } = detail || {}
  const {t} = useTranslation()
  return (
    <AppContainer
      sx={{
        backgroundColor: "#fff",
        padding: "0 !important"
      }}
      maxWidth={false}
    >
      <BannerSection imgSrc={cover || ""} name={name} />
      <Stack
        gap="48px"
        direction="column"
        margin="48px auto 0"
        paddingX="16px"
        maxWidth="1064px"
      >
        <TitleSection slug={slug} name={name} collectionId={id} likes={likes} />
        <BodySection content={content} />
        <RelativeProduct
          hiddenViewAll={true}
          label={t('products_in_collection')}
          relatedProducts={products || []}
        />
        <OtherCollections data={relatedCollection} />
      </Stack>
    </AppContainer>
  )
}
export default CollectionDetail
